import { HOT_RANK } from "@/mocks/news";

const rankColor = ["bg-primary-500", "bg-accent-500", "bg-secondary-500", "bg-background-300 text-foreground-700", "bg-background-300 text-foreground-700"];

export default function HotBoard() {
  return (
    <section id="hot" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex items-end justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              Trending Board
            </p>
            <h3 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              今日热点榜
            </h3>
            <p className="mt-2 text-sm text-foreground-600">
              全网热搜中的民生议题，看看大家正在关注什么。
            </p>
          </div>
          <a
            href="#latest"
            className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700 sm:flex"
          >
            全部资讯
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <ol className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {HOT_RANK.map((item, idx) => (
            <li
              key={item.title}
              className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-base font-bold text-background-50 ${rankColor[idx] ?? "bg-background-300 text-foreground-700"}`}
              >
                {idx + 1}
              </span>
              <div className="min-w-0">
                <p className="text-[15px] font-semibold leading-snug text-foreground-950">
                  {item.title}
                </p>
                <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-foreground-600">
                  <span className="inline-flex items-center gap-1 rounded-sm bg-primary-100 px-1.5 py-0.5 text-primary-700">
                    {item.category}
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-sm bg-accent-100 px-1.5 py-0.5 text-accent-800">
                    <i className="ri-fire-line"></i>
                    {item.heat}
                  </span>
                  <span className="text-foreground-400">{item.tag}</span>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}